module.exports = __webpack_public_path__ + "img/foot-logo.e084ec83.png";